<template>
  <v-layout disable-contact>
    <div class="map">

      <googlemaps-map
        ref="map"
        :center="center"
        :zoom.sync="zoom"
        class="map">

        <!-- Marker -->
        <googlemaps-marker
          ref="projectPlaceMarker"
          :position="center" :title="title" @click="showInfo"/>


      </googlemaps-map>

      <v-container v-if="!settings.disable_map_search_field" class="places">
        <v-autocomplete v-model="placesModel" :items="places" solo/>
      </v-container>

      <googlemaps-nearby-places
        v-if="placesModel" v-model="placesModel"
        :request="{
            location:center,
            radius:radius,
            keyword:placesModel
          }"
        @results="isPlacesResult"
      />

      <LocationPlaceInfo ref="locationPlaceInfo"/>

    </div>
  </v-layout>
</template>

<script>
import VLayout from '@/layouts/Default.vue';
import { mapActions, mapGetters } from 'vuex';
import LocationPlaceInfo from '@/components/LocationPlaceInfo.vue';
import { cdnUrl } from '@/utils/urls';

export default {
  /**
   * The name of the page.
   */
  name: 'OrderArea',

  data() {
    return {
      zoom: 15,
      title: 'home_marker',
      center: {
        lat: null,
        lng: null,
      },
      places: [],
      placesModel: null,
      radius: 1000,
      placesResult: [],
      map: null,
      markers: [],
    };
  },
  computed: {
    ...mapGetters('project', ['project', 'settings']),
  },
  beforeMount() {
    this.fillGeo();
  },
  components: {
    VLayout,
    LocationPlaceInfo,
  },
  methods: {
    ...mapActions('layout', [
      'toggleSideNav',
    ]),
    fillGeo() {
      if (this.project) {
        this.center.lat = parseFloat(this.project.lat, 10);
        this.center.lng = parseFloat(this.project.lng, 10);
        this.title = this.project.name || this.title;
        this.places = this.project.places_tags.map(item => item.replace('_', ' '));
        this.radius = this.project.places_radius;
      }
    },
    showInfo() {
      this.showPlaceInfo(this.$refs.projectPlaceMarker.$_marker, this.getProjectPlaceInfo());
    },
    showPlaceInfo(marker, projectInfo) {
      this.$refs.locationPlaceInfo.showPlaceInfo(
        projectInfo,
        marker,
        this.$refs.map.$_map
      );
    },
    getProjectPlaceInfo() {
      return {
        placeHeader: this.project.name,
        placeDescription: this.project.introduction,
        placePictureUrl: cdnUrl(`${this.project.gallery.find(item => item.image).image}?width=640&height=9999`),
      };
    },
    isPlacesResult(result) {
      this.placesResult = result;
      if (result && result.length) {
        this.markers.forEach(item => item.setMap(null));
        this.markers = [];
        result.forEach((place) => {
          const marker = new window.google.maps.Marker({
            title: place.name,
            position: place.geometry.location,
            icon: this.createIcon(),
          });
          marker.setMap(this.$refs.map.$_map);
          marker.addListener('click', () => this.showPlaceInfo(
            marker,
            {
              placeHeader: place.name,
              placeDescription: place.name,
              placePictureUrl: null,
              placeId: place.place_id,
            }
          ));
          this.markers.push(marker);
        });
      }
    },
    createIcon() {
      return { url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png' };
    },
  },
};
</script>
<style lang="scss">
.map {
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 100% 1 1;
}

.places {
  position: absolute;
  top: 40px;
  left: 25%;
  width: 50%;
}
</style>
